<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">ポイントカード基本情報設定</h4>
        </md-card-header>

        <md-card-content>
          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              表示順
            </label>
            <div class="md-layout-item">
              <md-field style="width: 50px" :class="[
                {'md-error': errors.has('number')},
                {'md-valid': !errors.has('number') && touched.number}]">
                <md-input
                  v-model="number"
                  data-vv-name="number"
                  type="text"
                  v-validate= "modelValidations.number"
                  required>
                </md-input>
                <slide-y-up-transition>
                  <div class="vErrorText" v-show="errors.has('number')">【必須】3桁以内の半角数字で入力してください</div>
                </slide-y-up-transition>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('number')">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('number') && touched.number">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              ポイントカード識別コード
            </label>
            <div class="md-layout-item">
              <md-field :class="[
                {'md-error': errors.has('code')},
                {'md-valid': !errors.has('code') && touched.code}]">
                <md-input
                  v-model="code"
                  data-vv-name="code"
                  type="text"
                  v-validate= "modelValidations.code"
                  required>
                </md-input>
                <slide-y-up-transition>
                  <div class="vErrorText" v-show="errors.has('code')">【必須】16文字以内で入力してください</div>
                </slide-y-up-transition>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('code')">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('code') && touched.code">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              ポイントカードサービス名
            </label>
            <div class="md-layout-item">
              <md-field :class="[
                {'md-error': errors.has('name')},
                {'md-valid': !errors.has('name') && touched.name}]">
                <md-input
                  v-model="name"
                  data-vv-name="name"
                  type="text"
                  v-validate= "modelValidations.name"
                  required>
                </md-input>
                <slide-y-up-transition>
                  <div class="vErrorText" v-show="errors.has('name')">【必須】16文字以内で入力してください</div>
                </slide-y-up-transition>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('name')">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('name') && touched.name">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>
          </div>
          
          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              ポイントカード説明文
            </label>
            <div class="md-layout-item">
              <md-field>
                <md-textarea id="txtArea" class="txtArea" v-model="description" md-counter="255" maxlength="255"></md-textarea>
              </md-field>
              <div class="iconWrapper">
                <div class="iconTrigger" @click="openEmoticon">顔文字を挿入する</div>
                <transition name="fade">
                  <div class="iconModal" v-if="modalFlag" @mouseleave="closeEmoticon">
                    <div class="icons" @click="insertEmoticon" v-for="(item,index) in icons" :key="index" v-html="icons[index]" :data-code="icons[index]"></div>
                  </div>
                </transition>
              </div>
              <slide-y-up-transition>
                <div class="vErrorText" v-show="errors.has('description')">【必須】255文字以内で入力してください</div>
              </slide-y-up-transition>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              サービス紹介URL
            </label>
            <div class="md-layout-item md-size-60 md-xsmall-size-100">
              <md-field :class="[
                {'md-error': errors.has('url')},
                {'md-valid': !errors.has('url') && touched.url}]">
                <md-input
                  v-model="url"
                  data-vv-name="url"
                  v-validate= "modelValidations.url">
                </md-input>
                <slide-y-up-transition>
                  <div class="vErrorText" v-show="errors.has('url')">半角英数記号のURL形式で入力してください（255文字以内）</div>
                </slide-y-up-transition>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('url')">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('url') && touched.url">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>
          </div>
          
          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              ステータス
            </label>
            <div class="md-layout-item md-size-20 md-xsmall-size-100">
              <md-field :class="[
                {'md-error': errors.has('status')},
                {'md-valid': !errors.has('status') && touched.status}]">
                <md-select
                  v-model="status"
                  data-vv-name="status"
                  v-validate= "modelValidations.status"
                  required>
                  <md-option value="active">有効</md-option>
                  <md-option value="not_active">無効</md-option>
                </md-select>
                <slide-y-up-transition>
                  <div class="vErrorText" v-show="errors.has('status')">【必須】必ず一つ選択してください</div>
                </slide-y-up-transition>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('status')" style="margin-right:20px">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('status') && touched.status" style="margin-right:20px">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              ポイント利用種別
            </label>
            <div class="md-layout-item md-size-20 md-xsmall-size-100">
              <md-field :class="[
                {'md-error': errors.has('useKind')},
                {'md-valid': !errors.has('useKind') && touched.useKind}]">
                <md-select
                  v-model="useKind"
                  data-vv-name="useKind"
                  v-validate= "modelValidations.useKind"
                  required>
                  <md-option value="only_prepaid">プリペイドのみ</md-option>
                  <md-option value="only_point">ポイントのみ</md-option>
                  <md-option value="both_available">併用あり</md-option>
                </md-select>
                <slide-y-up-transition>
                  <div class="vErrorText" v-show="errors.has('useKind')">【必須】必ず一つ選択してください</div>
                </slide-y-up-transition>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('useKind')" style="margin-right:20px">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('useKind') && touched.useKind" style="margin-right:20px">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-100 md-small-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              連携先システム種別
            </label>
            <div class="md-layout-item">
              <md-radio v-model="systemKind" value="valuegateway">ValueGateway</md-radio>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              連携先システム認証ID
            </label>
            <div class="md-layout-item md-size-60 md-xsmall-size-100">
              <md-field :class="[
                {'md-error': errors.has('login')},
                {'md-valid': !errors.has('login') && touched.login}]">
                <md-input
                  v-model="login"
                  data-vv-name="login"
                  v-validate= "modelValidations.login">
                </md-input>
                <slide-y-up-transition>
                  <div class="vErrorText" v-show="errors.has('login')">【必須】255文字以内の半角英数記号で入力してください</div>
                </slide-y-up-transition>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('login')">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('login') && touched.login">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              連携先システム認証PW
            </label>
            <div class="md-layout-item md-size-60 md-xsmall-size-100">
              <md-field :class="[
                {'md-error': errors.has('password')},
                {'md-valid': !errors.has('password') && touched.password}]">
                <md-input
                  v-model="password"
                  data-vv-name="password"
                  v-validate= "modelValidations.password">
                </md-input>
                <slide-y-up-transition>
                  <div class="vErrorText" v-show="errors.has('password')">【必須】255文字以内の半角英数記号で入力してください</div>
                </slide-y-up-transition>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('password')">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('password') && touched.password">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              連携先システム端末ID
            </label>
            <div class="md-layout-item md-size-60 md-xsmall-size-100">
              <md-field :class="[
                {'md-error': errors.has('terminalCode')},
                {'md-valid': !errors.has('terminalCode') && touched.terminalCode}]">
                <md-input
                  v-model="terminalCode"
                  data-vv-name="terminalCode"
                  v-validate= "modelValidations.terminalCode">
                </md-input>
                <slide-y-up-transition>
                  <div class="vErrorText" v-show="errors.has('terminalCode')">半角英数記号で入力してください（255文字以内）</div>
                </slide-y-up-transition>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('terminalCode')">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('terminalCode') && touched.terminalCode">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>
          </div>

          <category-detail
            :categoryData="brandData"
            v-on:get-categories="getBrands">
          </category-detail>

        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>settings</md-icon>
          </div>
          <h4 class="title">ポイントカード画像設定</h4>
        </md-card-header>

        <md-card-content>
          <div class="md-layout md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              イメージ画像
            </label>
            <div class="md-layout-item  md-size-30 md-xsmall-size-100">
              <div class="file-input">
                <div v-if="!imagePointCard">
                  <div class="image-container">
                    <img :src="dummyImg" title="">
                  </div>
                </div>
                <div class="image-container" v-else>
                  <img :src="imagePointCard" />
                </div>
                <div class="button-container">
                  <md-button class="md-danger md-round" @click="removeImage" v-if="imagePointCard" data-id="imagePointCard"><i class="fa fa-times"></i>削除</md-button>
                  <md-button class="md-success md-round md-fileinput">
                    <template v-if="!imagePointCard">画像選択</template>
                    <template v-else>変更</template>
                    <input type="file" @change="onFileChange" data-id="imagePointCard">
                  </md-button>
                </div>
              </div>
            </div>
          </div>

        </md-card-content>
        <md-card-actions md-alignment="left" class="mt60 mx-auto">
          <md-button class="md-warning md-lg" @click.native.prevent="returnBack">戻る</md-button>
          <submit-button class="md-success md-lg mL40" :onclick="validate" :buttonWord=this.buttonWord type="submit"></submit-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
  import SubmitButton from '../components/additional/SubmitButton.vue'
  import router from '../packs/router.js'
  import CategoryDetail from '../components/additional/CategoryDetail.vue'
  import qs from 'qs'
  import EventBus from '../mixins/event-bus.js';
  import role from "../mixins/role.js"
  import 'babel-polyfill'

  export default {
    mixins: [ role ],
    components: {
      SubmitButton,
      CategoryDetail
    },
    computed: {
    },
    props: {
      dummyImg: {
        type: String,
        default: '/images/image_placeholder.jpg'
      }
    },
    data () {
      return {
        id: '',
        buttonWord: '登録',
        number: '',
        name: '',
        code: '',
        imagePointCard: '',
        description: '',
        status: '',
        useKind: '',
        systemKind: 'valuegateway',
        login: '',
        password: '',
        terminalCode: '',
        url: '',
        newFlag: false,
        listData: [],
        brands: '',
        brandData: {
          title: "対応ブランド",
          apiUrl: '/brands/'
        },
        touched: {
          number: false,
          name: false,
          code: false,
          status: false,
          useKind: false,
          systemKind: false,
          login: false,
          terminalCode: false,
          password: false
        },
        modelValidations: {
          number: {
            required: true,
            numeric: true,
            max: 3
          },
          name: {
            required: true,
            max: 16
          },
          description: {
            required: true,
            max: 255
          },
          status: {
            required: true
          },
          code: {
            required: true,
            max: 16
          },
          useKind: {
            required: true,
          },
          systemKind: {
            max: 1
          },
          login: {
            required: true,
            max: 255
          },
          password: {
            required: true,
            max: 255
          },
          terminalCode: {
            max: 255
          },
          url:{
            url: true,
            max: 255
          }
        },
        modalFlag: false,
        icons: []
      }
    },
    methods: {
      returnBack () {
        router.push({ path: '/admin/point_card_list/' })
      },
      getBrands(brands){
        this.brands = brands  // $emitの第二引数のデータが入っている
      },
      getPointCards () {
        this.axios({
          method  : 'GET',
          url     : this.AdminApiUrl + '/point_cards/' + this.$route.params.id,
          timeout : 30000,
          headers : {'Authorization': this.$Cookies.get('accessToken')}
        }).then(response => {
          this.number = response.data.position
          this.code = response.data.code
          this.name = response.data.name
          this.description = response.data.description
          this.imagePointCard = response.data.image_url
          this.url = response.data.url          
          this.status = response.data.status
          this.useKind = response.data.use_kind
          this.systemKind = response.data.system_kind
          this.login = response.data.login
          this.password = response.data.password
          this.terminalCode = response.data.terminal_code
          // レンダリングの完了（CategoryDetailコンポーネント内のmounted処理終了）を待つため、5秒間、0.5秒間隔で確認する。
          this.createCategoryListLoop(response)
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.tokenError()
          } else {
            this.dangerNotify('ポイントカード情報を正しく取得できませんでした')
          }
        })
      },
      createCategoryList (array, obj) {
        array.splice(0)
        var parent = obj
        for (var i in parent) {
          var item = {
            id: parent[i].id,
            name: parent[i].name,
            children: [],
            openFlag: false,
            check: parent[i].checked
          }
          var child = parent[i].children
          for (var j in child) {
            var itemC = {
              id: child[j].id,
              name: child[j].name,
              children: [],
              openFlag: false,
              check: child[j].checked
            }
            for (var k in child[j].children) {
              var itemCC = {
                id: child[j].children[k].id,
                name: child[j].children[k].name,
                openFlag: false,
                check: child[j].children[k].checked
              }
              itemC.children.push(itemCC)
            }
            item.children.push(itemC)
          }
          array.push(item)
        }
      },
      sleep (time) {
        return new Promise(resolve => {
          setTimeout(resolve, time)
        })
      },
      async createCategoryListLoop (response) {
        try {
          for (let i = 0; i < 10; i++) {
            if (this.brands) {
              this.createCategoryList(this.brands, response.data.brands)
              break;
            } else if (i === 9) {
              throw 'ポイントカード情報を正しく取得できませんでした';
            } else {
              await this.sleep(500)
            }
          }
        } catch (error) {
          this.dangerNotify(error)
        }
      },
      onFileChange(e) {
        let files = e.target.files || e.dataTransfer.files;
        let ids = e.currentTarget.getAttribute('data-id');
        if (!files.length)
        return;
        this.createImage(files[0],ids);
      },
      createImage(file,fileId) {
        let reader = new FileReader();
        let $this = this;

        reader.onload = (e) => {
          $this[fileId] = e.target.result;
        };
        reader.readAsDataURL(file);
      },
      removeImage: function (e) {
        let ids = e.currentTarget.getAttribute('data-id');
        this[ids]= '';
      },
      validate() {
        return new Promise((resolve) => {
          setTimeout(() => {
            EventBus.$emit('validate', this.errors)
            this.$validator.validateAll().then(isValid => {
              if (this.errors.items.length == 0) {
                this.updateInformation()
              } else {
                this.validateError()
              }
            })
            resolve();
          }, this.ResolveTime);
        });
      },
      checkCategories (categories, text) {
        var checkedCategories = []
        for (var i in categories) {
          if (categories[i].check) {
            checkedCategories.push(categories[i].id)
          }
          var child = categories[i].children
          for (var j in child) {
            if (child[j].check) {
              checkedCategories.push(child[j].id)
            }
            for (var k in child[j].children) {
              if (child[j].children[k].check) {
              checkedCategories.push(child[j].children[k].id)
              }
            }
          }
        }
        if(checkedCategories.length === 0){
          this.validateError(text + "を一つ以上チェックして下さい。");
          exit;
        }
        return checkedCategories.join()
      },
      updateInformation(){
        var condition = {
          point_card: {
            position: this.number,
            code: this.code,
            name: this.name,
            image: this.imagePointCard,
            url: this.url,
            description: this.description,
            status: this.status,
            use_kind: this.useKind,
            system_kind: this.systemKind,
            login: this.login,
            password: this.password,
            terminal_code: this.terminalCode,
            brands: this.checkCategories(this.brands,"対応ブランド")
          }
        }

        // 画像がURLかどうか判別して追加
        if(this.imagePointCard === '' || this.imagePointCard === null){
          condition.point_card.image = ''
        } else if (this.imagePointCard.indexOf('/uploads/') == -1) {
          condition.point_card.image = this.imagePointCard
        }

        this.axios({
          method  : this.newFlag === true ? 'POST' : 'PUT',
          url     : this.newFlag === true ? this.AdminApiUrl + '/point_cards/' : this.AdminApiUrl + '/point_cards/' + this.$route.params.id,
          timeout : 30000,
          data: qs.stringify(condition),
          headers : {'Authorization': this.$Cookies.get('accessToken')}
        }).then(response => {
          this.successAndBackPage(`ポイントカードを`+this.buttonWord+`しました`,'/admin/point_card_list/')
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.tokenError()
          } else {
            this.dangerNotify(`ポイントカードを正しく`+this.buttonWord+`できませんでした`)
          }
        })
      },
      dateDivider (dates) {
        var dateArray = dates.split('T')
        return dateArray
      },
      resetData () {
        this.number = ''
        this.status = 'not_active'
        this.code = ''
        this.name = ''
        this.url = ''
        this.useKind = ''
        this.status = ''
        this.systemKind = ''
        this.login = ''
        this.password = ''
        this.terminalCode = ''
        this.imagePointCard = ''
        this.description = ''
        this.brands = ''
        this.$validator.reset()
        setTimeout (times =>{
          for (var key in this.touched) {
            this.touched[key] = false
          }
        },100)
      },
      closeEmoticon () {
        this.modalFlag = false
      },
      openEmoticon () {
        this.modalFlag = true
        var doms = document.getElementById('txtArea')
        this.cursorPos = doms.selectionStart
      },
      insertEmoticon (e) {
        this.modalFlag = false
        var emoicons = e.target.getAttribute('data-code')
        var txt = this.description
        this.description = txt.substr(0, this.cursorPos) + emoicons + txt.substr(this.cursorPos, txt.length)
      }
    },
    mounted () {
      // role check
      if (this.shopFlag || !this.opt_coupon) {
        router.push({ path: '/admin/login'})
        return false
      }
      var url = location.href
      url = url.split('/')
      if(url[url.length - 1] === 'new') {
        this.newFlag = true
      } else {
        this.buttonWord = '更新'
        this.getPointCards()
      }
      //Icon
      this.icons = this.TextIcons
    },
    watch: {
      '$route.path'(value){
        if (value.match('new')) {
          this.newFlag = true
          this.buttonWord = '登録'
          this.resetData()
        } else {
          this.newFlag = false
          this.buttonWord = '更新'
          this.getPointCards()
        }
      },
      number () {
        this.touched.position = true
      },
      name(){
        this.touched.name = true
      },
      code(){
        this.touched.code = true
      },
      status(){
        this.touched.status = true
      },
      description(){
        this.touched.description = true
      },
      url(){
        this.touched.url = true
      },
      useKind(){
        this.touched.useKind = true
      },
      systemKind(){
        this.touched.systemKind = true
      },
      login(){
        this.touched.login = true
      },
      password(){
        this.touched.password = true
      },
      terminalCode(){
        this.touched.terminalCode = true
      },
      imagePointCard(){
        this.touched.imagePointCard = true
      }

    }
  }
</script>

<style lang="css" scoped>
.md-card .md-card-actions{
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.md-size-2{
  width: 2%;
  min-width: 2%;
  max-width: 2%;
}

.md-aSize-100{
  width: 100px;
  min-width: 100px;
  max-width: 100px;
}

.md-aSize-120{
  width: 120px;
  min-width: 120px;
  max-width: 120px;
}

.btnCenter{
  margin-left: auto !important;
  margin-right: auto !important;
}

.mt60{
  margin-top: 60px;
}
.zipBetween{
  padding: 10px 0 0 0;
  text-align: center;
  line-height: 46px;
}

.unitLabel{
  padding: 10px 0 0 0;
  line-height: 46px;
}

.weekLabel{
  font-weight: bold !important;
  text-align: left !important;
}

.timeLabel{
  font-weight: normal !important;
  text-align: left !important;
  padding: 20px 5px 0 0;
  font-size: 12px;
  color: #666666;
}

.weekLabelSelect{
  font-weight: bold !important;
  text-align: left !important;
  padding-top: 0 !important;
}
.is-red{
  color: #f44336 !important;
}

.is-restRed{
  color: #d9333f !important;
}

.is-blue{
  color: #4496d3 !important;
}

.addBtn{
  margin-top: 20px;
}

.addLabel{
  display: inline-block;
  line-height: 41px;
  margin: 5px 0;
}

.pt5{
  padding-top: 5px;
}

.mt-20{
  margin-top: 20px;
}

.pt20{
  padding-top: 20px;
}

.text-center{
  text-align: center;
}

.is-l-none{
  display: none;
}

.error{
  color: #f44336 !important;
}

.success{
  color: #4caf50 !important
}

.md-input{
  width: 100%;
}

.productStatus{
  max-width: 120px;
  width: 100%;
  display: inline-block;
}

.emptyError{
  color: #f44336 !important;
  font-size: 12px;
  position: absolute;
  top: 0;
  left: 0;
}

.is-xs-block{
  display: none;
}

.iconWrapper{
  position: relative;
}

.iconTrigger{
  font-size: 12px;
  color: #666666;
  padding: 5px 0;
}

.iconModal{
  position: absolute;
  left: 0;
  top: 0;
  background: #ffffff;
  border-radius: 4px;
  width: 250px;
  padding: 5px;
  font-size: 0;
  z-index: 1050;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, .14);
}

.icons{
  display: inline-block;
  font-size: 14px;
  width: 25px;
  text-align: center;
  margin: 2px;
}

.icons:hover{
  background-color: #ccccff;
  cursor: pointer;
}

@media screen and (max-width:600px) {
  .md-card .md-card-content .md-form-label{
    text-align: left;
  }

  .is-xs-none{
    display: none;
  }

  .is-xs-block{
    display: block;
  }

  .timeLabel{
    line-height: 14px;
  }

  .weekLabel{
    margin-left: -5px !important;
  }
}

</style>
